// extracted by mini-css-extract-plugin
module.exports = {"icon":"CustomIcon_icon__18ieo"};